

interface PositivePdca {
    description: string;
    list: string[];
}

interface NegativePdca {
    description: string;
    list: string[];
}

interface LessonsLearnedPdca {
    description: string;
    list: string[];
}

interface StandardizationActionsPdca {
    description: string;
    list: string[];
}



export class ConclusionPdca {
    positive: PositivePdca = { description: '', list: [] };
    negative: NegativePdca = { description: '', list: [] };
    lessonsLearned: LessonsLearnedPdca = { description: '', list: [] };
    standardizationActions: StandardizationActionsPdca = { description: '', list: [] };
}